import React from "react";

const ParloaIcon: React.FunctionComponent = () => (
  <img alt="parloa icon" src="assets/svg/parloa.svg" />
);

export default ParloaIcon;
